import { useState, useMemo, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { formatDateString, showStudentURL } from "../../../utils/textUtils";
import { refinePages } from "../../../utils/paginationUtils";

import { fetchLevels } from "../../student/studentSlice";
import { fetchAssignments } from "../assignmentListSlice";

import InsertLinkIcon from "@mui/icons-material/InsertLink";

import Pagination from "../../../components/Pagination";
import WorksheetTypeBox from "./common/WorksheetTypeBox";
import CustomCheckbox from "../../../components/CustomCheckbox";
import WorksheetSearchBar from "./common/WorksheetSearchBar";
import DeleteWorksheetModal from "./common/DeleteWorksheetModal";
import FilteringTab from "./common/FilteringTab/FilteringTab";

const UnfinishedWorksheetTable = () => {
  const dispatch = useDispatch();

  const { levels, allStudents } = useSelector((state) => state.student);
  const { results, current_page, total_pages } = useSelector(
    (state) => state.assignments
  );

  const [selectedParams, setSelectedParams] = useState({
    levelId: null,
    studentId: null,
  });
  const [selectedAssignments, setSelectedAssignments] = useState([]);
  const [keyword, setKeyword] = useState("");

  const visiblePages = useMemo(
    () => refinePages({ total_pages, current_page }),
    [current_page, total_pages]
  );

  useEffect(() => {
    dispatch(
      fetchAssignments({
        page: 1,
        isFinished: false,
        keyword: keyword,
        levelId: selectedParams.levelId,
        studentId: selectedParams.studentId,
        studentGrade: selectedParams.studentGrade,
      })
    );
    dispatch(fetchLevels());
    setSelectedAssignments([]);
  }, [dispatch, keyword, selectedParams]);

  const handleCheckboxChange = (checked, assignment) => {
    if (checked) {
      // 체크 O
      setSelectedAssignments((prev) => [...prev, assignment]);
    } else {
      // 체크 해제
      setSelectedAssignments((prev) =>
        prev.filter((prevAssignment) => prevAssignment.id !== assignment.id)
      );
    }
  };

  //   (2) 헤더(전체선택) 체크박스 핸들러
  const handleHeaderCheckboxChange = (checked) => {
    if (checked) {
      setSelectedAssignments(results);
    } else {
      // 해제
      setSelectedAssignments([]);
    }
  };

  // (3) 헤더 체크박스가 "완전히 체크" 상태인지 판별 (현재 페이지 모두 체크된 경우)
  const isHeaderChecked =
    results.length > 0 &&
    results.every((currentAssignment) =>
      selectedAssignments.some(
        (selectedAssignment) => selectedAssignment.id === currentAssignment.id
      )
    );

  const handlePageClick = (page) => {
    dispatch(
      fetchAssignments({
        page,
        isFinished: false,
        keyword: keyword,
        levelId: selectedParams.levelId,
        studentId: selectedParams.studentId,
        studentGrade: selectedParams.studentGrade,
      })
    );
  };

  return (
    <div
      style={{
        padding: "10px",
        maxWidth: "1400px",
        margin: "0 auto",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h3 style={{ marginRight: "auto" }}>과제 미완수자 명단</h3>
        <div style={{ width: "30%", marginRight: "10px" }}>
          <WorksheetSearchBar handleFilter={setKeyword} />
        </div>
        <button
          style={{
            padding: "10px 30px",
            fontSize: "18px",
            borderRadius: "5px",
            backgroundColor: "#FFF",
            border: "1px solid #438CFB",
            color: "#438CFB",
          }}
          onClick={(e) => {
            alert("알림톡 전송 기능은 준비 중입니다.");
          }}
        >
          알림톡 전송
        </button>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "stretch",
          marginTop: "10px",
        }}
      >
        <FilteringTab
          levels={levels}
          allStudentList={allStudents}
          selectedParams={selectedParams}
          setSelectedParams={setSelectedParams}
        />
        <div
          style={{
            width: "85%",
            backgroundColor: "#FFF",
            paddingBottom: "5px",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
            }}
          >
            <colgroup>
              <col style={{ width: "6%" }} />
              <col style={{ width: "12%" }} />
              <col style={{ width: "180px" }} />
              <col />
              <col style={{ width: "8%" }} />
              <col style={{ width: "8%" }} />
            </colgroup>
            <tbody>
              <tr
                style={{
                  textAlign: "left",
                  borderBottom: "1px solid #EBEBEB",
                  fontSize: "16px",
                  color: "#737373",
                }}
              >
                <td style={{ textAlign: "center" }}>
                  <CustomCheckbox
                    onChange={(e) =>
                      handleHeaderCheckboxChange(e.target.checked)
                    }
                    checked={isHeaderChecked}
                  />
                </td>
                <td style={{ padding: "10px" }}>이름</td>
                <td style={{ padding: "10px", paddingLeft: "15px" }}>링크</td>
                <td style={{ padding: "10px" }}>학습지명</td>
                <td style={{ padding: "10px" }}>출제일</td>
                <td style={{ padding: "10px" }}>마감일</td>
              </tr>
              {results &&
                results.map((item, index) => {
                  const isChecked = selectedAssignments.includes(item);
                  return (
                    <tr
                      key={item.id}
                      style={{
                        fontSize: "18px",
                      }}
                    >
                      <td
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <CustomCheckbox
                          checked={isChecked}
                          onChange={(e) =>
                            handleCheckboxChange(e.target.checked, item)
                          }
                        />
                      </td>
                      <td style={{ padding: "10px" }}>{item.student.name}</td>
                      <td style={{ padding: "10px" }}>
                        <button
                          style={{
                            display: "flex",
                            gap: "5px",
                            alignItems: "center",
                            backgroundColor: "#F6F8FA",
                            border: "1px solid #EBEBEB",
                            borderRadius: "5px",
                            fontSize: "16px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            navigator.clipboard
                              .writeText(showStudentURL(item.student.session))
                              .then(() => {
                                alert("URL이 클립보드에 복사되었습니다!"); // 복사 성공 시 알림
                              })
                              .catch((err) => {
                                console.error("클립보드 복사 실패: ", err); // 복사 실패 시 오류 출력
                              });
                          }}
                        >
                          <InsertLinkIcon />
                          <span>URL 복사하기</span>
                        </button>
                      </td>
                      <td
                        style={{
                          padding: "10px",
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                        }}
                      >
                        {item.is_retry && (
                          <span style={{
                            backgroundColor: "#e8f5e8",
                            color: "#2e7d32",
                            padding: "4px 8px",
                            borderRadius: "4px",
                            fontSize: "12px",
                            marginLeft: "8px",
                            marginRight: "8px",
                            fontWeight: "bold"
                          }}>
                            복습 {item.retry_info?.retry_count || ''}회차
                          </span>
                        )}
                        {item.title}
                        <WorksheetTypeBox type={item.type} />
                      </td>
                      <td style={{ padding: "10px" }}>
                        {formatDateString(item.created_at)}
                      </td>
                      <td style={{ padding: "10px" }}>
                        {item.closed_at ? formatDateString(item.closed_at) : "-"}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>

          {/* 페이지네이션 */}
          <Pagination
            visiblePages={visiblePages}
            current_page={current_page}
            handlePageClick={handlePageClick}
          />
        </div>
        {selectedAssignments.length > 0 && (
          <DeleteWorksheetModal
            worksheets={selectedAssignments}
            setSelectedWorksheets={setSelectedAssignments}
            type={"assignment"}
          />
        )}
      </div>
    </div>
  );
};

export default UnfinishedWorksheetTable;
